var _linearGradient, _clipPath, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57,
    height: 20,
    role: "img",
    "aria-label": "Unity",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Unity") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 57,
    height: 20,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmZmZmIiByb2xlPSJpbWciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+VW5pdHk8L3RpdGxlPjxwYXRoIGQ9Im0xMi45Mjg4IDQuMjkzOSAzLjc5OTcgMi4xOTI5Yy4xMzY2LjA3Ny4xNDE1LjI5MDUgMCAuMzY3NWwtNC41MTUgMi42MDc2YS40MTkyLjQxOTIgMCAwIDEtLjQyNDYgMEw3LjI3NCA2Ljg1NDNjLS4xMzktLjA3NDUtLjE0MTUtLjI5MyAwLS4zNjc1bDMuNzk3Mi0yLjE5M1YwTDEuMzc1OCA1LjU5NzdWMTYuNzkzbDMuNzE3Ny0yLjE0NTZ2LTQuMzg1OGMtLjAwMjUtLjE1NjUuMTgxMy0uMjY4Mi4zMTgtLjE4MzhsNC41MTQ4IDIuNjA3NmEuNDI1Mi40MjUyIDAgMCAxIC4yMTM2LjM2NzZ2NS4yMTI3Yy4wMDI1LjE1NjUtLjE4MTMuMjY4Mi0uMzE3OS4xODM4bC0zLjc5OTYtMi4xOTI5LTMuNzE3OCAyLjE0NTdMMTIgMjRsOS42OTU0LTUuNTk3Ny0zLjcxNzgtMi4xNDU3LTMuNzk5NiAyLjE5MjljLS4xMzQxLjA4Mi0uMzIyOS0uMDI0OC0uMzE3OS0uMTgzOFYxMy4wNTNjMC0uMTU2NS4wODctLjI5NTYuMjEzNi0uMzY3Nmw0LjUxNDktMi42MDc2Yy4xMzQtLjA4Mi4zMjI4LjAyMjQuMzE3OS4xODM4djQuMzg1OGwzLjcxNzcgMi4xNDU2VjUuNTk3N0wxMi45Mjg4IDBaIi8+PC9zdmc+"
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 375,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 290
  }, "Unity"), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 290
  }, "Unity"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnity);
export default __webpack_public_path__ + "static/media/unity.b28ec530dff208eb55ba454f16e43bd1.svg";
export { ForwardRef as ReactComponent };